import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'itl-desktop-page',
  templateUrl: './desktop-page.component.html',
  styleUrls: ['./desktop-page.component.scss'],
  standalone: false,
})
export class DesktopPageComponent implements OnInit {
  @Input() showActionBar = true;
  constructor() {}

  ngOnInit() {}
}
